function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRightSmall = function SvgCaretRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "caret-right-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M1.00098 4.5L4.50098 8L1.00098 11.5",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgCaretRightSmall.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCaretRightSmall"
};
export default SvgCaretRightSmall;